import { Controller } from "@hotwired/stimulus"

// Opens share modal on button click; copy link, close on overlay click or after choosing an option.
export default class extends Controller {
  static targets = ["overlay", "panel", "copyLabel"]
  static values = { url: String }

  connect() {
    this.boundCloseOnOverlay = this.closeOnOverlayClick.bind(this)
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    this.closeModal()
    document.removeEventListener("click", this.boundCloseOnOverlay)
    document.removeEventListener("keydown", this.boundCloseOnEscape)
  }

  openModal(event) {
    event.preventDefault()
    event.stopPropagation()
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.add("share-modal-open")
    document.addEventListener("click", this.boundCloseOnOverlay)
    document.addEventListener("keydown", this.boundCloseOnEscape)
  }

  closeModal() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.remove("share-modal-open")
    document.removeEventListener("click", this.boundCloseOnOverlay)
    document.removeEventListener("keydown", this.boundCloseOnEscape)
  }

  closeOnOverlayClick(event) {
    if (event.target !== this.overlayTarget) return
    this.closeModal()
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.closeModal()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  copy(event) {
    event.preventDefault()
    const url = this.urlValue
    if (!url) return
    navigator.clipboard.writeText(url).then(() => {
      if (this.hasCopyLabelTarget) {
        const orig = this.copyLabelTarget.textContent
        this.copyLabelTarget.textContent = "Copied!"
        setTimeout(() => { this.copyLabelTarget.textContent = orig }, 2000)
      }
      this.closeModal()
    })
  }
}
